import { Dispatch, SetStateAction } from 'react'

import { ISelectedPlatform, TPlatformValue } from '@/types/uploadForm.interface'

export const uploadSrtError = ({
	selectedPlatform,
	setSelectedPlatformList
}: {
	selectedPlatform: TPlatformValue | null
	setSelectedPlatformList: Dispatch<SetStateAction<ISelectedPlatform[]>>
}) => {
	if (!selectedPlatform) return

	setSelectedPlatformList(prev => {
		const otherPlatforms = prev.filter(plat => plat.value !== selectedPlatform)
		const currentPlatform = prev.find(plat => plat.value === selectedPlatform)

		return [
			...otherPlatforms,
			{
				...currentPlatform,
				headerState: 'error'
			}
		]
	})
}
